export default __webpack_public_path__ + "static/white-logo-6c8ffa5ca717c682f94819001ec9db66.png";